import '@gjensidige/grid-css';
// import '@gjensidige/core-global-css';
// import '@gjensidige/core-utilities-css';

import React from 'react';
import { Provider } from 'react-redux';
import { Routes, Route } from 'react-router-dom';
import { TrackingProvider } from '@gjensidige/core-analytics';
import { BuildersComponentsTrackingProvider } from '@gjensidige/builders-components';
import { store } from './store/store';
import tracker from './tracking';
import PurchaseFlow from './product/PurchaseFlow';

function App() {
  return (
    <Provider store={store}>
      <BuildersComponentsTrackingProvider options={tracker.options}>
        <TrackingProvider options={tracker.options}>
          <Routes>
            <Route path="/:product/:page" element={<PurchaseFlow />} />
          </Routes>
        </TrackingProvider>
      </BuildersComponentsTrackingProvider>
    </Provider>
  );
}

export default App;
